import { PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS } from '../actions/parts_equipments_work_orders_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const partsEquipmentsWorkOrdersRestCrudThunksForBuyer = new RestCrudThunks(
	'work_order_parts_equipments',
	'work_order_parts_equipment',
	'workOrderPartsEquipment',
	'workOrderPartsEquipment',
	PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'work_order/'
);
export const partsEquipmentsWorkOrdersRestCrudThunksForSupplier = new RestCrudThunks(
	'work_order_parts_equipments',
	'work_order_parts_equipment',
	'workOrderPartsEquipment',
	'workOrderPartsEquipment',
	PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'work_order/'
);

export const removePartFromWorkOrder = (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_order_parts_equipments/${entity.workOrderId}/remove_part/${entity.partId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(
							PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
						);
						reject(d.message);
					} else {
						dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(
						PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
					);
					reject(d.message);
				});
		});
	};
};

export const removeEquipmentFromWorkOrder = (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_order_parts_equipments/${entity.workOrderId}/remove_equipment/${entity.equipmentPerStockLocationId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(
							PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
						);
						reject(d.message);
					} else {
						dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(
						PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
					);
					reject(d.message);
				});
		});
	};
};

export const updatePartsOnWorkOrderWithPartsPerStockLocation = (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_order_parts_equipments/${entity.workOrderId}/part/${entity.partId}/count/${entity.quantity}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(
							PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
						);
						reject(d.message);
					} else {
						dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(
						PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
					);
					reject(d.message);
				});
		});
	};
};

export const addEquipmentToWorkOrder = (roleType) => (entity) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_order_parts_equipments/${entity.workOrderId}/add_equipment/${entity.equipmentPerStockLocationId}`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

			fetchUtils
				.patch(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						dispatch(
							PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
						);
						reject(d.message);
					} else {
						dispatch(PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(
						PARTS_EQUIPMENTS_WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity)
					);
					reject(d.message);
				});
		});
	};
};

export const getWorkOrderTotalPartsCost = (roleType) => (workOrderId) => {
	const baseUrl = getBackendUri();
	const apiUrl = `/api/v1/${roleType}/work_order/work_order_parts_equipments/${workOrderId}/total_parts_cost`;
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			fetchUtils
				.get(baseUrl + apiUrl, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (status === 401) {
						dispatch(logoutSuccess());
					}
					if (d.status === 'error') {
						reject(d.message);
					} else {
						resolve(d.data);
					}
				})
				.catch((d) => {
					reject(d.message);
				});
		});
	};
};
